import { gsap } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

function renderTips () {
  const template = $('#template-tip-hero')

  $('.tr-tl-block-js').each(function (index) {
    const $this = $(this)
    const idBlock = 'block-0' + (index + 1)
    $this.attr('id', `${idBlock}-scroll-js`)
    const icon = $this.data('icon')
    const title = $this.data('title')
    let cloneTemplate = template.clone().removeAttr('id')

    cloneTemplate.attr('data-title-anchor', idBlock)
    cloneTemplate
      .find('.template-tip-icon-js')
      .attr({
        src: icon,
        alt: `${title} tip`,
      })
      .removeClass('template-tip-icon-js')
    cloneTemplate
      .find('.template-tip-title-js')
      .html(title)
      .removeClass('template-tip-title-js')

    cloneTemplate
      .removeClass('hide')
      .addClass(`tip-section-0${index + 1}`)
      .appendTo('.tr-tl-hero-content-js')
  })
}

export const initLifecycleFunc = () => {
  renderTips()

  $(document).on('click', '.tip-section-js, .tr-tl-hero__scroll-down', function () {
    let anchorLink = $(this).attr('data-title-anchor')
    const element = $(`#${anchorLink}-scroll-js`)
    if (element) {
      const offset = element.offset()
      // const windowHeight = $(window).outerHeight(true);
      // const coor = offset.top - windowHeight / 2;
      const coor = offset.top - 110
      gsap.to(window, { duration: 1, ease: 'sine', scrollTo: coor })
    }
  })
}
